export default __webpack_public_path__ + "static/media/mental-health@2x.2e37e15f.png";